// File browser navigation: breadcrumbs and parent-directory controls.

import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const styles = {
  browser: {
    padding: '16px 24px',
    borderBottom: '1px solid #e0e0e0',
    backgroundColor: '#f9f9f9'
  },
  controls: {
    marginBottom: '12px'
  },
  backButton: {
    padding: '6px 12px',
    backgroundColor: '#f0f0f0',
    border: '1px solid #ddd',
    borderRadius: '4px',
    fontSize: '14px',
    cursor: 'pointer',
    transition: 'all 0.2s'
  },
  backButtonDisabled: {
    opacity: 0.5,
    cursor: 'not-allowed'
  },
  breadcrumbs: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    flexWrap: 'wrap',
    marginBottom: '8px',
    overflowX: 'auto',
    paddingBottom: '4px'
  },
  breadcrumb: {
    padding: '4px 8px',
    backgroundColor: 'transparent',
    border: 'none',
    color: '#0066cc',
    cursor: 'pointer',
    fontSize: '13px',
    whiteSpace: 'nowrap',
    transition: 'all 0.2s',
    borderRadius: '3px'
  },
  breadcrumbActive: {
    color: '#333',
    fontWeight: 600,
    backgroundColor: 'rgba(0, 102, 204, 0.05)',
    cursor: 'default'
  },
  separator: {
    color: '#999',
    margin: '0 2px',
    fontSize: '12px',
    userSelect: 'none'
  },
  pathDisplay: {
    fontSize: '11px',
    color: '#999',
    fontFamily: '"Monaco", "Courier New", monospace',
    backgroundColor: 'white',
    padding: '4px 8px',
    borderRadius: '3px',
    border: '1px solid #eee',
    wordBreak: 'break-all',
    maxHeight: '40px',
    overflowY: 'auto'
  }
};
export function FileBrowser({
  currentPath,
  onNavigate,
  onParentDirectory
}) {
  function getBreadcrumbs(path) {
    const breadcrumbs = [{
      label: 'Root',
      path: '/'
    }];
    if (path === '/') {
      return breadcrumbs;
    }
    const parts = path.split('/').filter(p => p);
    let currentBreadcrumbPath = '/';
    parts.forEach(part => {
      currentBreadcrumbPath = `${currentBreadcrumbPath}${part}/`;
      breadcrumbs.push({
        label: part,
        path: currentBreadcrumbPath
      });
    });
    return breadcrumbs;
  }
  const breadcrumbs = getBreadcrumbs(currentPath);
  const canGoUp = currentPath !== '/';
  return _jsxs("div", {
    style: styles.browser,
    children: [_jsx("div", {
      style: styles.controls,
      children: _jsx("button", {
        style: {
          ...styles.backButton,
          ...(canGoUp ? {} : styles.backButtonDisabled)
        },
        onClick: onParentDirectory,
        disabled: !canGoUp,
        title: "Go to parent directory",
        onMouseEnter: canGoUp ? e => e.currentTarget.style.backgroundColor = '#e0e0e0' : undefined,
        onMouseLeave: canGoUp ? e => e.currentTarget.style.backgroundColor = '#f0f0f0' : undefined,
        children: "\u2190 Back"
      })
    }), _jsx("div", {
      style: styles.breadcrumbs,
      children: breadcrumbs.map((breadcrumb, index) => _jsxs(React.Fragment, {
        children: [index > 0 && _jsx("span", {
          style: styles.separator,
          children: "/"
        }), _jsx("button", {
          style: {
            ...styles.breadcrumb,
            ...(breadcrumb.path === currentPath ? styles.breadcrumbActive : {})
          },
          onClick: () => onNavigate(breadcrumb.path),
          onMouseEnter: breadcrumb.path !== currentPath ? e => e.currentTarget.style.backgroundColor = 'rgba(0, 102, 204, 0.1)' : undefined,
          onMouseLeave: breadcrumb.path !== currentPath ? e => e.currentTarget.style.backgroundColor = 'transparent' : undefined,
          children: breadcrumb.label
        })]
      }, breadcrumb.path))
    }), _jsx("div", {
      style: styles.pathDisplay,
      children: currentPath
    })]
  });
}
export default FileBrowser;